import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/areaFinanciera/seriesFacturas';
import SerieFacturaCrear from './SerieFacturaCrear';

const ms2p = (state) => {
    return {
        ...state.seriesFacturas,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(SerieFacturaCrear);
